import React, { useState } from "react";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Moment from "react-moment";
import "moment-timezone";
import { FORMAT_DATETIME_MOMENT } from "../../api/constant";
const initialState = {
  text: "",
};

const Observations = ({ observations, actionNewObservation }) => {
  const [state, setstate] = useState(initialState);
  const { text } = state;
  const addNewObservation = async () => {
    actionNewObservation(text);
    setstate({ ...state, text: "" });
  };
  return (
    <section className="container-fluid w-100">
      <div className="input-observation-entry w-100 flex">
        <textarea
          value={text}
          placeholder="observaciones"
          onChange={(e) => setstate({ ...state, text: e.target.value })}
          className="flex1 font2"
          name="text"
        ></textarea>
        &nbsp;
        <div className=" flex-column justify-end">
          {text.length !== 0 && (
            <FontAwesomeIcon
              onClick={() => addNewObservation()}
              className="blue flex cursor-pointer icon-plus"
              icon={faPlusSquare}
            />
          )}
        </div>
      </div>

      {observations.map((ob) => {
        return (
          <div key={ob.id} className="comment-entry">
            <span className="font1">
              <Moment format={FORMAT_DATETIME_MOMENT}>{ob.created_at}</Moment> -{" "}
              {ob.user}:
            </span>
            &nbsp;<span>{ob.note}</span>
          </div>
        );
      })}
    </section>
  );
};

export default Observations;
